export { default as translations } from './translations.json';

export const TOKEN_TTL_MINUTES = 10;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validate an email for magic link request.
 * @param {string} email
 * @returns {string|null} — error message or null
 */
export const validateMagicLinkEmail = (email) => {
  if (!email || !email.trim()) return 'Email is required';
  if (!EMAIL_REGEX.test(email)) return 'Valid email address required';
  return null;
};
